import createClient from "openapi-fetch";
import type { paths } from "@api/schema";
import type { ValidationMessage } from "./types";

export const api = createClient<paths>({ baseUrl: "", credentials: "include" });

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly messages: ValidationMessage[] = [],
  ) {
    super(message);
  }
}

interface Problem {
  title?: string;
  messages?: ValidationMessage[];
}

/** Unwraps an openapi-fetch result and turns problem responses into {@link ApiError}. */
export async function call<T>(promise: Promise<{ data?: T; error?: unknown; response: Response }>): Promise<T> {
  const { data, error, response } = await promise;
  if (!response.ok) {
    const problem = (error ?? {}) as Problem;
    throw new ApiError(response.status, problem.title ?? `Fehler ${response.status}`, problem.messages ?? []);
  }
  return data as T;
}

export async function upload<T>(url: string, file: File, fields: Record<string, string> = {}): Promise<T> {
  const form = new FormData();
  form.append("file", file);
  for (const [key, value] of Object.entries(fields)) form.append(key, value);
  const response = await fetch(url, { method: "POST", body: form, credentials: "include" });
  const body = (await response.json().catch(() => ({}))) as Problem & T;
  if (!response.ok) throw new ApiError(response.status, body.title ?? `Fehler ${response.status}`, body.messages ?? []);
  return body;
}

export function downloadUrl(path: string): string {
  return path;
}
